import { Inject, Injectable } from '@angular/core';
import { RxapDataSource } from 'eurogard-data-source';
import { GetByFilterToTableMethod } from './get-by-filter-to-table.method';
import { DynamicTableDataSource } from 'eurogard-data-source/table';
import {
  ReportTemplateControllerGetByFilterRemoteMethod
} from 'open-api-legacy/remote-methods/report-template-controller-get-by-filter.remote-method';

@Injectable()
@RxapDataSource('report-template-table')
export class ReportTemplateTableDataSource extends DynamicTableDataSource {
  constructor(@Inject(ReportTemplateControllerGetByFilterRemoteMethod) getByFilter: ReportTemplateControllerGetByFilterRemoteMethod) {
    super(new GetByFilterToTableMethod(getByFilter));
  }
}
